import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CATEGORIES } from '../../utils/constants';

const Navigation = ({ mobileMenuOpen }) => {
  const location = useLocation();

  const categories = [
    { key: CATEGORIES.ALL,    label: 'All',    path: '/all'    },
    { key: CATEGORIES.WOMEN,  label: 'Women',  path: '/women'  },
    { key: CATEGORIES.MEN,    label: 'Men',    path: '/men'    },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-navy-light border-b border-primary/20">
      <div className="container mx-auto px-4">
        {/* Desktop nav */}
        <div className="hidden md:flex justify-center space-x-8 py-4">
          {categories.map(category => (
            <Link
              key={category.key}
              to={category.path}
              className={`font-medium transition duration-300 ${
                isActive(category.path)
                  ? 'text-primary border-b-2 border-primary pb-1'
                  : 'text-gray-800 hover:text-primary'
              }`}
            >
              {category.label}
            </Link>
          ))}
          {/* <Link
            to="/sale"
            className={`font-medium transition duration-300 ${
              isActive('/sale')
                ? 'text-primary border-b-2 border-primary pb-1'
                : 'text-red-600 hover:text-primary'
            }`}
          >
            Sale
          </Link> */}
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-primary/20">
            <div className="mb-4">
              <input
                type="text"
                placeholder="Search products..."
                className="w-full py-2 pl-4 pr-10 border border-primary/30 rounded-full bg-navy text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>
            <div className="flex flex-col space-y-3">
              {categories.map(category => (
                <Link
                  key={category.key}
                  to={category.path}
                  className={`font-medium transition duration-300 ${
                    isActive(category.path)
                      ? 'text-primary'
                      : 'text-gray-800 hover:text-primary'
                  }`}
                >
                  {category.label}
                </Link>
              ))}
              <Link to="/sale" className="text-red-600 hover:text-primary font-medium transition duration-300">
                Sale
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;